// Bible data loaded from real Bible JSON
import bibleDataJson from './bibleData.json';

// Convert JSON data to the format expected by the app
const oldTestamentBooks = [
  'genesis', 'exodo', 'levitico', 'numeros', 'deuteronomio',
  'josue', 'jueces', 'rut', '1_samuel', '2_samuel',
  '1_reyes', '2_reyes', '1_cronicas', '2_cronicas', 'esdras',
  'nehemias', 'ester', 'job', 'salmos', 'proverbios',
  'eclesiastes', 'cantares', 'isaias', 'jeremias', 'lamentaciones',
  'ezequiel', 'daniel', 'oseas', 'joel', 'amos',
  'abdias', 'jonas', 'miqueas', 'nahum', 'habacuc',
  'sofonias', 'hageo', 'zacarias', 'malaquias'
];

const newTestamentBooks = [
  'mateo', 'marcos', 'lucas', 'juan', 'hechos',
  'romanos', '1_corintios', '2_corintios', 'galatas', 'efesios',
  'filipenses', 'colosenses', '1_tesalonicenses', '2_tesalonicenses', '1_timoteo',
  '2_timoteo', 'tito', 'filemon', 'hebreos', 'santiago',
  '1_pedro', '2_pedro', '1_juan', '2_juan', '3_juan',
  'judas', 'apocalipsis'
];

// Build BIBLE_BOOKS structure from JSON data
export const BIBLE_BOOKS = {
  OLD_TESTAMENT: oldTestamentBooks
    .filter(id => bibleDataJson[id])
    .map(id => ({
      id: id,
      name: bibleDataJson[id].name,
      chapters: bibleDataJson[id].totalChapters,
      totalVerses: bibleDataJson[id].totalVerses,
      progress: 0
    })),
  NEW_TESTAMENT: newTestamentBooks
    .filter(id => bibleDataJson[id])
    .map(id => ({
      id: id,
      name: bibleDataJson[id].name,
      chapters: bibleDataJson[id].totalChapters,
      totalVerses: bibleDataJson[id].totalVerses,
      progress: 0
    }))
};

// Daily verse feature - selected meaningful verses
export const DAILY_VERSES = [
  { text: 'Lámpara es a mis pies tu palabra, y lumbrera a mi camino.', reference: 'Salmos 119:105' },
  { text: 'Porque de tal manera amó Dios al mundo, que ha dado a su Hijo unigénito, para que todo aquel que en él cree, no se pierda, mas tenga vida eterna.', reference: 'Juan 3:16' },
  { text: 'Fíate de Jehová de todo tu corazón, y no te apoyes en tu propia prudencia.', reference: 'Proverbios 3:5' },
  { text: 'Todo lo puedo en Cristo que me fortalece.', reference: 'Filipenses 4:13' },
  { text: 'Jehová es mi pastor; nada me faltará.', reference: 'Salmos 23:1' },
  { text: 'En el principio creó Dios los cielos y la tierra.', reference: 'Génesis 1:1' },
  { text: 'Mas buscad primeramente el reino de Dios y su justicia, y todas estas cosas os serán añadidas.', reference: 'Mateo 6:33' },
  { text: 'Yo soy el camino, y la verdad, y la vida; nadie viene al Padre, sino por mí.', reference: 'Juan 14:6' },
  { text: 'Venid a mí todos los que estáis trabajados y cargados, y yo os haré descansar.', reference: 'Mateo 11:28' },
  { text: 'Y conoceréis la verdad, y la verdad os hará libres.', reference: 'Juan 8:32' },
];

// Get verses for a specific book - now returns real data
export const getVersesForBook = (bookId) => {
  const bookData = bibleDataJson[bookId];
  if (!bookData) {
    return { totalChapters: 0, chapters: {}, allVerses: [] };
  }

  // Convert chapters to the format with verse objects
  const formattedChapters = {};
  const allVerses = [];

  Object.keys(bookData.chapters)
    .sort((a, b) => parseInt(a) - parseInt(b))
    .forEach(chapterNum => {
      const verses = bookData.chapters[chapterNum];
      formattedChapters[chapterNum] = verses.map((text, index) => ({
        chapter: parseInt(chapterNum),
        verse: index + 1,
        text: text,
        reference: `${bookData.name} ${chapterNum}:${index + 1}`,
        bookId: bookId
      }));
      allVerses.push(...formattedChapters[chapterNum]);
    });

  return {
    totalChapters: bookData.totalChapters,
    chapters: formattedChapters,
    allVerses
  };
};

// Get verses for a specific chapter
export const getVersesForChapter = (bookId, chapterNumber) => {
  const bookData = bibleDataJson[bookId];
  if (!bookData || !bookData.chapters[chapterNumber]) {
    return [];
  }

  return bookData.chapters[chapterNumber].map((text, index) => ({
    chapter: parseInt(chapterNumber),
    verse: index + 1,
    text: text,
    reference: `${bookData.name} ${chapterNumber}:${index + 1}`
  }));
};

// Get a random daily verse
export const getDailyVerse = () => {
  const today = new Date().getDate();
  return DAILY_VERSES[today % DAILY_VERSES.length];
};

// Get book info by ID
export const getBookInfo = (bookId) => {
  return bibleDataJson[bookId] || null;
};

// Get all books
export const getAllBooks = () => {
  return [...BIBLE_BOOKS.OLD_TESTAMENT, ...BIBLE_BOOKS.NEW_TESTAMENT];
};
